// import {WalletService} from "@/services/wallet.service";
import {BayarTempoService} from "@/services/bayartempo.service";
import moment from "moment";
// import moment from "moment";

const state = {
    loading: false,
    dialog: false,
    overlay: false,
    total_bills: 0,
    bills: [],
    rekenings: [],
    detailBills: [],
    dialogConfitmation: false,
    activeId: null,
    loadingDialog: false,
    wallet: {
        limit: 0,
        totalbill: 0,
        status: ""
    },
    dialogResult: {
        show: false,
        type: 'success',
        message: ''
    },
    modalAddRekening: false,
    virtualAccount: [],
    modalCashout: false,
    loadingCashout: false,
    cashBalance: {
        amount: 0,
        limit: 0,
        totalLimit: 0,
        requestLimit: 0,
        name: "-"
    },
    rekeningCashout: []
}
const actions = {
    getVirtualAccount({ commit }, opti) {
        BayarTempoService.fectVirtualAccount(opti).then(data=>{

            const valist = data.data;

            for(var i = 0; i < valist.length; i++){
                switch (valist[i].bank) {
                    case "BCA":
                        valist[i].avatar = "https://irmastore.id/icon/bank/bca-circle.png"
                        break;
                    case "BNI":
                        valist[i].avatar = "https://irmastore.id/icon/bank/bni_cicrle.png"
                        break;
                    case "BRI":
                        valist[i].avatar = "https://irmastore.id/icon/bank/bri-circle.png"
                        break;
                    case "MANDIRI":
                        valist[i].avatar = "https://irmastore.id/icon/bank/mandiri-circle.png"
                        break;
                }
            }

            commit('setVirtualAccount',valist)
        }).catch(error=>{
            console.log(error);
        });
    },
    toggledialog({ commit }, data) {
        commit('toggleDialog');
        commit('setDetailBills',data)
    },
    toggleDialogCashout({ commit }) {
        commit('toggleDialogCashout');
    },
    toggleLoadingCashout({ commit }) {
        commit('toggleLoadingCashout');
    },
    toggleDialogResult({ commit }, data) {
        commit('toggleDialogResult', data);
    },
    toggleConfirmation({ commit }, data) {
        commit('toggleConfirmation');
        commit('setActiveId', data);
    },
    closedialog({ commit }) {
        commit('toggleDialog');
    },
    getBills({ commit }, opti){
        console.log("get bills")
        commit('setloading',true);
        BayarTempoService.getBills(opti).then(data=>{
            commit('setloading',false);
            commit('addBillsData', data);
        }).catch(error=>{
            commit('setloading',false);
            console.log(error);
        });
    },
    getRekenings({ commit }, opti){
        console.log("get rekening")
        commit('setloading',true);
        BayarTempoService.fetchRekening(opti).then(data=>{
            commit('setloading',false);
            commit('addRekeningData', data);
        }).catch(error=>{
            commit('setloading',false);
            console.log(error);
        });
    },
    getRekeningCashout({ commit }, opti){
        BayarTempoService.fetchRekening(opti).then(data=>{
            commit('addRekeningCashout', data);
        }).catch(error=>{
            console.log(error);
        });
    },
    updateBill({ commit }, opti){
        console.log("update bills")
        commit('toggleLoadingDialog');
        BayarTempoService.updateBills(opti).then(data => {
            commit('toggleLoadingDialog');
            commit('toggleConfirmation');
            commit('toggleDialogResult', {
                show: true,
                type: data.data.statuscode == "00" ? 'success' : 'error',
                message: data.data.msg
            })
            if(data.data.statuscode == "00"){
                commit('setloading',true);
                BayarTempoService.getBills({
                    search:'',
                    itemsPerPage: 10,
                    page:1,
                    sortBy: ["id"],
                    awal: moment().add(7,'hours').toISOString().substr(0, 10),
                    akhir: moment().add(7,'hours').toISOString().substr(0, 10),
                }).then(data=>{
                    commit('setloading',false);
                    commit('addBillsData', data);
                }).catch(error=>{
                    commit('setloading',false);
                    console.log(error);
                });
            }
        }).catch(error=>{
            commit('toggleLoadingDialog');
            commit('toggleConfirmation');
            console.log(error);
        });
    },
    addRekening({ commit }, opti){
        console.log("add rekening")
        commit('toggleLoadingDialog');
        BayarTempoService.addRekening(opti).then(data => {
            commit('toggleLoadingDialog');
            commit('toggleModalAddRekening');

            commit('toggleDialogResult', {
                show: true,
                type: data.statuscode == "00" ? 'success' : 'error',
                message: data.msg
            })

            if(data.statuscode == "00"){
                commit('setloading',true);
                BayarTempoService.fetchRekening({}).then(data=>{
                    commit('setloading',false);
                    commit('addRekeningData', data);
                }).catch(error=>{
                    commit('setloading',false);
                    console.log(error);
                });
            }

        }).catch(error=>{
            commit('toggleLoadingDialog');
            commit('toggleModalAddRekening');
            console.log(error);
        });
    },
    manualCashout({ commit }, opti){
        commit('toggleLoadingDialog');
        BayarTempoService.doCashout(opti).then(data => {
            commit('toggleLoadingDialog');
            commit('toggleDialogCashout');

            commit('toggleDialogResult', {
                show: true,
                type: data.data.response_code == "200" ? 'success' : 'error',
                message: data.data.response_message
            })

        }).catch(error=>{
            commit('toggleLoadingDialog');
            commit('toggleDialogCashout');
            console.log(error);
        });
    },
    getBalance({ commit }, opti){

        BayarTempoService.getBalance(opti).then(data => {

            commit('setCashbalance', {
                amount: data.data.accountBalance,
                name: data.data.customerName,
                limit: data.data.limit.toString(),
                totalLimit: data.data.totalLimit.toString(),
                requestLimit: data.data.requestLimit.toString()
            })

        }).catch(error=>{
            console.log(error);
        });
    },
    toggleLoadingDialog({ commit }) {
        commit('toggleLoadingDialog');
    },
    toggleModalAddRekening({commit}){
        commit('toggleModalAddRekening');
    }
}
const mutations = {
    setActiveId(state, w){
        state.activeId = w.id
    },
    setVirtualAccount(state, w){
        state.virtualAccount = w
    },
    toggleModalAddRekening(state){
        state.modalAddRekening = !state.modalAddRekening
    },
    toggleDialogCashout(state){
        state.modalCashout = !state.modalCashout
    },
    toggleLoadingCashout(state){
        state.loadingCashout = !state.loading
    },
    toggleDialog(state){
        state.dialog = !state.dialog
    },
    toggleLoadingDialog(state){
        state.loadingDialog = !state.loadingDialog
    },
    toggleConfirmation(state){
        state.dialogConfitmation = !state.dialogConfitmation
    },
    setDetailBills(state, w){
        state.detailBills = w.bills
    },
    setloading(state,load) {
        state.loading = load
        state.overlay = load
    },
    toggleDialogResult(state,data) {
        state.dialogResult = data
    },
    setCashbalance(state,data) {
        state.cashBalance = {
            amount: data.amount,
            name: data.name,
            limit: data.limit,
            totalLimit: data.totalLimit,
            requestLimit: data.requestLimit
            }
    },
    addBillsData(state, w) {
        state.bills = w.data.content
        state.total_bills = w.data.totalElements
        state.wallet.totalbill = w.data.amount
        state.wallet.status = w.data.status
        state.wallet.limit = w.data.content.length > 0 ? w.data.content[0].serpul.limit : 0
        state.loading = false
        state.dialog = false
        state.overlay= false
    },
    addRekeningData(state, w) {
        state.rekenings = w.data
    },
    addRekeningCashout(state, w) {
        let tmpData = [];

        for(let i = 0; i < w.data.length; i++){
            tmpData.push("#"+ w.data[i].id + " " + w.data[i].name +" | "+w.data[i].bankNo)
        }

        state.rekeningCashout = tmpData
    },
}

export const Bayartempo = {
    namespaced: true,
    state,
    actions,
    mutations
};
